import { ExternalLinkIcon } from 'lucide-react';
import { FormattedMessage } from 'react-intl';

export function InstallationSteps(): JSX.Element {
  return (
    <div className="mt-8 p-6 border border-gray-200 dark:border-gray-700 rounded-lg bg-white dark:bg-gray-900">
      <div className="flex flex-row justify-between items-center mb-4">
        <h4 className="font-semibold text-gray-900 dark:text-gray-100">
          <FormattedMessage id="integrations.containers.kubernetes.installationSteps.title" />
        </h4>
        <a
          href="https://docs.anyshift.io/pages/integration/kubernetes"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 underline"
        >
          <FormattedMessage id="integrations.containers.kubernetes.installationSteps.documentation" />
          <ExternalLinkIcon className="ml-1 h-4 w-4" />
        </a>
      </div>
      <ol className="text-gray-700 dark:text-gray-300 space-y-2 text-sm list-decimal list-inside">
        <li>
          <FormattedMessage id="integrations.containers.kubernetes.installationSteps.step1" />
        </li>
        <li>
          <FormattedMessage id="integrations.containers.kubernetes.installationSteps.step2" />
        </li>
        <li>
          <FormattedMessage id="integrations.containers.kubernetes.installationSteps.step3" />
        </li>
        <li>
          <FormattedMessage id="integrations.containers.kubernetes.installationSteps.step4" />
        </li>
      </ol>
    </div>
  );
}
